// app/routes/app.login.tsx
import type { ActionFunctionArgs, LoaderFunctionArgs } from "@remix-run/node";
import { Form } from "@remix-run/react";
import type { MetaFunction } from "@remix-run/node";

import { authenticator } from "~/services/auth.server";

export const meta: MetaFunction = () => {
  return [
    { title: "EasyGo | Login" },
    { name: "description", content: "EasyGo" },
  ];
};

// First we create our UI with the form doing a POST and the inputs with the
// names we are going to use in the strategy
export default function LoginPage() {
  return (
    <div className='container mt-4'>
      <div className='row'>
        <div className='col-12 col-lg-4 offset-lg-4 text-center'>
          <Form method="post">
            <h2 className='my-4 pt-4'> Log In </h2>
            <div className='card my-4 p-4'>
              <div className='form-field text-start py-2'>
                <label> Username </label><br/>
                <input type="text" name="username" required className='form-control' />
              </div>

              <div className='form-field text-start py-2 mb-4'>
                <label> Password </label><br/>
                <input
                  type="password"
                  name="password"
                  className='form-control'
                  autoComplete="current-password"
                  required
                />
              </div>
              <button className='btn btn-success'>Log In</button>
            </div>
          </Form>
        </div>
      </div>
    </div>
  );
}

// Second, we need to export an action function, here we will use the
// `authenticator.authenticate method`
export async function action({ request }: ActionFunctionArgs) {
  // we call the method with the name of the strategy we want to use and the
  // request object, optionally we pass an object with the URLs we want the user
  // to be redirected to after a success or a failure
  return await authenticator.authenticate("user-pass", request, {
    successRedirect: "/app/orders",
    failureRedirect: "/login",
  });
};

// Finally, we can export a loader function where we check if the user is
// authenticated with `authenticator.isAuthenticated` and redirect to the
// dashboard if it is or return null if it's not
export async function loader({ request }: LoaderFunctionArgs) {
  // If the user is already authenticated redirect to /dashboard directly
  return await authenticator.isAuthenticated(request, {
    successRedirect: "/app/orders",
  });
};
